import { render, staticRenderFns } from "./ResultBlock.vue?vue&type=template&id=75952a64&"
import script from "./ResultBlock.vue?vue&type=script&lang=js&"
export * from "./ResultBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports